import React, { useState, useEffect } from 'react'
import styles from './ActionsPage.module.css'

const API_URL = process.env.REACT_APP_API_URL || ''

function getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
}

// Inline SVG icons replacing all emojis
const SvgBag    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M8 12V8a4 4 0 014-4v0a4 4 0 014 4v4"/><path d="M3.694 12.668c.145-1.741.218-2.611.792-3.14C5.06 9 5.934 9 7.681 9h8.639c1.746 0 2.62 0 3.194.528.574.528.647 1.399.792 3.14l.514 6.166c.084 1.013.126 1.52-.17 1.843-.298.323-.806.323-1.824.323H5.174c-1.017 0-1.526 0-1.823-.323-.297-.323-.255-.83-.17-1.843l.513-6.166z"/></svg>
const SvgBook   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M4 4.5A2.5 2.5 0 016.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15z"/></svg>
const SvgNews   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M7 8h10M7 12h10M7 16h6"/></svg>
const SvgCal    = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
const SvgStar   = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
const SvgPencil = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
const SvgGrad   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M22 10v6M2 10l10-5 10 5-10 5-10-5z"/><path d="M6 12v5c0 2 4 3 6 3s6-1 6-3v-5"/></svg>
const SvgLink   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>
const SvgLightning = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M13 2L4.09 12.54H11L10 22l8.91-10.54H13L14 2z"/></svg>

const SvgClipboard = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="9" y="2" width="6" height="4" rx="1"/><path d="M9 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2h-2"/></svg>
const SvgTrophy = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 9H4.5a2.5 2.5 0 010-5H6"/><path d="M18 9h1.5a2.5 2.5 0 000-5H18"/><path d="M4 22h16M12 17v5"/><rect x="6" y="2" width="12" height="13" rx="2"/></svg>
const SvgTrash  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>

const ACTION_CONFIG = {
    TAILOR_CV:   { icon: <SvgPencil />, label: 'Tailor CV',   color: '#7c3aed', bg: '#7c3aed18' },
    TAKE_COURSE: { icon: <SvgGrad />,   label: 'Take Course', color: '#0ea5e9', bg: '#0ea5e918' },
    READ_NEWS:   { icon: <SvgNews />,   label: 'Read News',   color: '#10b981', bg: '#10b98118' },
    APPLY:       { icon: <SvgBag />,    label: 'Apply',       color: '#f59e0b', bg: '#f59e0b18' },
}
const RELATED_ICON = { job: <SvgBag />, course: <SvgBook />, news: <SvgNews />, event: <SvgCal /> }
const getConfig = (t) => ACTION_CONFIG[t] || { icon: <SvgLightning />, label: t || 'Action', color: '#432C5B', bg: '#432C5B18' }

const SECTION_ORDER = ['job', 'course', 'news', 'event', 'other']
const SECTION_META  = {
    job:    { icon: <SvgBag />,  label: 'Jobs' },
    course: { icon: <SvgBook />, label: 'Courses' },
    news:   { icon: <SvgNews />, label: 'News' },
    event:  { icon: <SvgCal />,  label: 'Events' },
    other:  { icon: <SvgStar />, label: 'Custom' },
}

function getPrimaryItemInfo(row) {
    const ct = row.content_type
    if (ct === 'job')    return { title: row.job_title    || '', subtitle: row.job_company    || '', url: row.job_url }
    if (ct === 'course') return { title: row.course_title || '', subtitle: row.course_provider || '', url: row.course_url }
    if (ct === 'news')   return { title: row.news_title   || '', subtitle: row.news_publisher  || '', url: row.news_url }
    if (ct === 'event')  return { title: row.event_title  || '', subtitle: row.event_location  || '', url: row.event_url }
    return { title: '', subtitle: '', url: null }
}

function getRelatedItemInfo(row) {
    const ct = row.related_content_type
    if (!ct) return null
    if (ct === 'job')    return { title: row.related_job_title,    subtitle: row.related_job_company,      url: row.related_job_url,    type: ct, action_id: row.action_id }
    if (ct === 'course') return { title: row.related_course_title,  subtitle: row.related_course_provider,  url: row.related_course_url,  type: ct, action_id: row.action_id }
    if (ct === 'news')   return { title: row.related_news_title,    subtitle: row.related_news_publisher,   url: row.related_news_url,   type: ct, action_id: row.action_id }
    if (ct === 'event')  return { title: row.related_event_title,   subtitle: row.related_event_location,   url: row.related_event_url,  type: ct, action_id: row.action_id }
    return null
}

/**
 * Groups flat DB rows into { contentType → [{ primaryItem, action_type, description, relatedItems[] }] }
 */
function groupActions(rows) {
    const groupMap = {}
    rows.forEach(row => {
        const isCustom = row.action_type === 'CUSTOM' || !row.primary_content_id;
        const key = isCustom ? `custom:${row.action_id}` : `${row.primary_content_id}:${row.action_type}`
        if (!groupMap[key]) {
            const primaryInfo = getPrimaryItemInfo(row)
            groupMap[key] = {
                key,
                content_type:       isCustom ? 'other' : row.content_type,
                action_type:        row.action_type,
                title:              row.title || '',
                description:        row.description || '',
                primary_content_id: row.primary_content_id,
                action_id:          row.action_id,
                primaryItem:        primaryInfo,
                relatedItems:       [],
            }
        }
        if (!isCustom) {
            const related = getRelatedItemInfo(row)
            if (related && related.title) {
                groupMap[key].relatedItems.push(related)
            }
        }
    })

    // Group by content_type
    const byCt = {}
    Object.values(groupMap).forEach(g => {
        const ct = g.content_type || 'other'
        if (!byCt[ct]) byCt[ct] = []
        byCt[ct].push(g)
    })
    return byCt
}

const ActionsPage = () => {
    const [grouped, setGrouped]   = useState({})
    const [total, setTotal]       = useState(0)
    const [loading, setLoading]   = useState(true)
    const [loadingMore, setLoadingMore] = useState(false)
    const [error,   setError]     = useState(null)
    const [expanded, setExpanded] = useState({ job: true, course: true, news: true, event: true, other: true })
    
    // Tab State: 'accepted' (Active), 'completed', 'dismissed' (Removed)
    const [activeTab, setActiveTab] = useState('accepted')
    // Pagination state
    const [page, setPage] = useState(0)
    const LIMIT = 10

    // Fetch on tab change or page change
    useEffect(() => {
        const fetchActions = async () => {
            if (page === 0) setLoading(true)
            else setLoadingMore(true)
            
            setError(null)
            try {
                const token = getCookie('token')
                const headers = token ? { Authorization: `Bearer ${token}` } : {}
                const res = await fetch(`${API_URL}/feed/user-actions?status=${activeTab}&limit=${LIMIT}&offset=${page * LIMIT}`, { headers })
                
                if (!res.ok) throw new Error(`Failed: ${res.status}`)
                const data = await res.json()
                
                setTotal(data.totalCount || 0)
                
                const g = groupActions(Array.isArray(data.actions) ? data.actions : [])
                
                if (page === 0) {
                    setGrouped(g)
                } else {
                    // Merge new groups into existing
                    setGrouped(prev => {
                        const next = { ...prev }
                        Object.keys(g).forEach(ct => {
                            if (!next[ct]) next[ct] = []
                            next[ct] = [...next[ct], ...g[ct]]
                        })
                        return next
                    })
                }
            } catch (err) {
                console.error('[ActionsPage] fetch error:', err)
                setError(err.message)
            } finally {
                setLoading(false)
                setLoadingMore(false)
            }
        }
        fetchActions()
    }, [activeTab, page])

    // Change tab handler
    const handleTabChange = (tab) => {
        if (tab === activeTab) return
        setActiveTab(tab)
        setPage(0)
        setGrouped({})
        setTotal(0)
    }

    const toggle = (key) => setExpanded(prev => ({ ...prev, [key]: !prev[key] }))

    // Update status handler (Complete or Remove)
    const handleUpdateStatus = async (itemType, itemKey, actionObj, newStatus) => {
        try {
            const token = getCookie('token')
            const body = actionObj.primary_content_id 
                ? { primary_content_id: actionObj.primary_content_id, action_type: actionObj.action_type, new_status: newStatus }
                : { action_id: actionObj.action_id, new_status: newStatus }

            const res = await fetch(`${API_URL}/feed/action-status`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                },
                body: JSON.stringify(body),
            })

            if (!res.ok) throw new Error('Failed to update status')

            // Optimistic UI update: Remove the item from the current view
            setGrouped(prev => {
                const next = { ...prev }
                if ('primaryItem' in actionObj) {
                    // Removed whole group (including custom actions which have primaryItem but no primary_content_id)
                    next[itemType] = next[itemType].filter(g => g.key !== itemKey)
                } else {
                    // Removed individual sub-item
                    next[itemType] = next[itemType].map(g => {
                        if (g.key === itemKey) {
                            return {
                                ...g,
                                relatedItems: g.relatedItems.filter(r => r.action_id !== actionObj.action_id)
                            }
                        }
                        return g
                    }).filter(g => g.relatedItems.length > 0 || g.description) // clean up empty groups
                }
                return next
            })
            setTotal(prev => prev - 1) // rough estimate

        } catch (err) {
            console.error('Update status failed:', err)
            alert('Failed to update action status.')
        }
    }

    // Render loading state if initial load
    if (loading && page === 0) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.spinner} />
                <p className={styles.loadingText}>Loading actions…</p>
            </div>
        )
    }

    if (error && page === 0) {
        return (
            <div className={styles.errorContainer}>
                <p className={styles.errorText}>⚠️ Could not load actions: {error}</p>
            </div>
        )
    }

    const currentCount = Object.values(grouped).flat().length
    const hasMore = currentCount < total

    return (
        <div className={styles.page}>
            {/* Hero */}
            <div className={styles.hero}>
                <div className={styles.heroInner}>
                    <h1 className={styles.heroTitle}>My Actions</h1>
                    <p className={styles.heroSub}>
                         Manage your career steps. Keep track of what you need to do, and review your progress over time.
                    </p>
                </div>
                
                {/* Tabs */}
                <div className={styles.tabs}>
                    <button 
                        className={`${styles.tab} ${activeTab === 'accepted' ? styles.tabActive : ''}`}
                        onClick={() => handleTabChange('accepted')}
                    >
                        <SvgPencil /> Active
                    </button>
                    <button 
                        className={`${styles.tab} ${activeTab === 'completed' ? styles.tabActive : ''}`}
                        onClick={() => handleTabChange('completed')}
                    >
                        <SvgTrophy /> Completed
                    </button>
                    <button 
                        className={`${styles.tab} ${activeTab === 'dismissed' ? styles.tabActive : ''}`}
                        onClick={() => handleTabChange('dismissed')}
                    >
                        <SvgTrash /> Removed
                    </button>
                </div>
            </div>

            {/* Empty state */}
            {total === 0 && !loading && (
                <div className={styles.emptyState}>
                    <div className={styles.emptyIcon}>{activeTab === 'accepted' ? <SvgClipboard /> : activeTab === 'completed' ? <SvgTrophy /> : <SvgTrash />}</div>
                    <h3 className={styles.emptyTitle}>
                        {activeTab === 'accepted' ? "You don't have any active actions" 
                        : activeTab === 'completed' ? "No completed actions yet" 
                        : "No removed actions"}
                    </h3>
                    <p className={styles.emptySub}>
                        {activeTab === 'accepted' 
                        ? <>Go to your <strong>Weekly Shortlist</strong>, expand an item card, and click <strong>+ Add Action</strong>.</>
                        : "Your history will appear here once you manage your active actions."}
                    </p>
                </div>
            )}

            {/* Grouped sections */}
            {SECTION_ORDER.map(ct => {
                const list = grouped[ct]
                if (!list || list.length === 0) return null
                const meta = SECTION_META[ct]

                return (
                    <div key={ct} className={styles.section}>
                        <div className={styles.sectionHeader} onClick={() => toggle(ct)}>
                            <span className={styles.sectionEmoji}>{meta.icon}</span>
                            <h2 className={styles.sectionTitle}>
                                {meta.label}
                                <span className={styles.sectionCount}>{list.length}</span>
                            </h2>
                            <span className={styles.chevron}>{expanded[ct] ? '▼' : '▶'}</span>
                        </div>

                        {expanded[ct] && (
                            <div className={styles.cardList}>
                                {list.map(group => {
                                    const config = getConfig(group.action_type)
                                    const { primaryItem } = group
                                    return (
                                        <div key={group.key} className={styles.actionCard}>
                                            {/* Primary item context (hide if custom) */}
                                            {group.content_type !== 'other' && (
                                                <div className={styles.itemContext}>
                                                    {primaryItem.url ? (
                                                        <a href={primaryItem.url} target="_blank" rel="noopener noreferrer" className={styles.itemTitle}>
                                                            {primaryItem.title || 'Unknown Item'} →
                                                        </a>
                                                    ) : (
                                                        <span className={styles.itemTitle}>{primaryItem.title || 'Unknown Item'}</span>
                                                    )}
                                                    {primaryItem.subtitle && (
                                                        <span className={styles.itemSubtitle}>{primaryItem.subtitle}</span>
                                                    )}
                                                </div>
                                            )}

                                            {group.content_type !== 'other' && <div className={styles.divider} />}

                                            {/* Action type + description */}
                                            <div className={styles.actionMeta}>
                                                <div className={styles.actionPillDesc}>
                                                    <span className={styles.typePill} style={{ background: config.bg, color: config.color }}>
                                                        {config.icon} {config.label}
                                                    </span>
                                                    <div className={styles.actionDesc}>
                                                        {group.title && <strong>{group.title}</strong>}
                                                        {group.title && group.description && <span> - </span>}
                                                        {group.description}
                                                    </div>
                                                </div>
                                                
                                                {/* Group Management Buttons (Only if no related items exist!) */}
                                                {activeTab === 'accepted' && group.relatedItems.length === 0 && (
                                                    <div className={styles.manageBtns}>
                                                        <button 
                                                            className={styles.completeBtn} 
                                                            onClick={() => handleUpdateStatus(ct, group.key, group, 'completed')}
                                                            title="Mark as Completed"
                                                        >
                                                            Complete
                                                        </button>
                                                        <button 
                                                            className={styles.removeBtn} 
                                                            onClick={() => handleUpdateStatus(ct, group.key, group, 'dismissed')}
                                                            title="Remove Action"
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Related content (courses / articles / events) */}
                                            {group.relatedItems.length > 0 && (
                                                <div className={styles.relatedList}>
                                                    {group.relatedItems.map((item, i) => (
                                                        <div key={i} className={styles.relatedChipWrapper}>
                                                            <a
                                                                href={item.url || '#'}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className={styles.relatedChip}
                                                                onClick={e => !item.url && e.preventDefault()}
                                                            >
                                                                <span className={styles.relatedIcon}>{RELATED_ICON[item.type] || <SvgLink />}</span>
                                                                <span className={styles.relatedTitle}>{item.title}</span>
                                                                {item.subtitle && <span className={styles.relatedSub}> · {item.subtitle}</span>}
                                                                {item.url && <span className={styles.relatedArrow}>↗</span>}
                                                            </a>
                                                            
                                                            {/* Individual Item Management */}
                                                            {activeTab === 'accepted' && item.action_id && (
                                                                <div className={styles.manageBtnsChip}>
                                                                    <button 
                                                                        className={styles.completeBtnSmall} 
                                                                        onClick={() => handleUpdateStatus(ct, group.key, item, 'completed')}
                                                                        title="Mark this item completed"
                                                                    >
                                                                        Complete
                                                                    </button>
                                                                    <button 
                                                                        className={styles.removeBtnSmall} 
                                                                        onClick={() => handleUpdateStatus(ct, group.key, item, 'dismissed')}
                                                                        title="Remove this item"
                                                                    >
                                                                        Remove
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                )
            })}

            {/* Load More Pagination */}
            {hasMore && (
                <div className={styles.loadMoreContainer}>
                    <button 
                        className={styles.loadMoreBtn}
                        onClick={() => setPage(p => p + 1)}
                        disabled={loadingMore}
                    >
                        {loadingMore ? 'Loading...' : `Load Next 10 (Showing ${currentCount} of ${total})`}
                    </button>
                </div>
            )}
        </div>
    )
}

export default ActionsPage
